import Store from 'store/store';
import { parseDate } from 'utils/utils';
import formatDateTime from 'utils/formatDateTime';
import getCopyWithParams from 'utils/getCopyWithParams';

function getToday() {
	const now = new Date();
	return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

function isReleaseWeek(dateStr, date = parseDate(dateStr)) {
	const today = getToday();

	// Only check for fully qualified dates
	if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;
	if (!date || today >= date) return false;

	const mondayBeforeRelease = new Date(+date);
	mondayBeforeRelease.setDate(mondayBeforeRelease.getDate() - (mondayBeforeRelease.getDay() + 6) % 7);
	return today >= mondayBeforeRelease;
}

export function getReleaseDateFormat(movie, copy = Store.get().appData?.copy?.baseCopy) {
	const releaseDateStr = movie.dates?.release;
	if (!releaseDateStr) return '';

	const releaseDate = parseDate(releaseDateStr);
	const now = new Date();

	let dateFormat = copy?.['$RELEASE_DATE_FORMAT_COMPACT'] || 'MMMM d';
	if (/^\d{4}$/.test(movie.dates.release)) {
		dateFormat = copy?.['$RELEASE_DATE_FORMAT_YEAR_ONLY'] || 'yyyy';
	} else if (/^\d{4}-\d{2}$/.test(movie.dates.release)) {
		dateFormat = copy?.['$RELEASE_DATE_FORMAT_MONTH_ONLY'] || 'MMMM yyyy';
	} else if (now.getFullYear() !== releaseDate.getFullYear()) {
		dateFormat = copy?.['$RELEASE_DATE_FORMAT'] || 'MMMM d, yyyy';
	}

	return dateFormat;
}

export function getReleaseMessaging(movie, status = movie?.status, copy = Store.get().appData?.copy?.baseCopy) {
	if (movie?.releaseMessagingOverride) {
		return movie.releaseMessagingOverride;
	}

	if (!movie || !status) return '';

	if (status.theaters === 'inTheaters' && status.homeEnt === 'homeEnt') {
		// return 'In Theaters and At Home';
		return copy?.['$RELEASE_THEATERS_HOMEENT'] || 'In Theaters and At Home';
	}

	if (status.theaters === 'inTheaters') {
		return copy?.['$RELEASE_THEATERS'] || 'Now Playing In Theaters';
	}

	if (status.homeEnt === 'homeEnt') {
		return copy?.['$RELEASE_HOMEENT'] || 'Watch At Home';
	}

	if (status.theaters === 'comingSoon' || status.theaters === 'preSale') {
		const releaseDateStr = movie.dates?.release;

		if (!releaseDateStr) {
			return copy?.['$RELEASE_COMING_SOON'] || 'Coming Soon';
		}

		const releaseDate = parseDate(releaseDateStr);

		if (isReleaseWeek(releaseDateStr, releaseDate)) {
			return getCopyWithParams(
				{ DAY: formatDateTime(releaseDate, copy?.['$RELEASE_DATE_FORMAT_DAY_OF_WEEK'] || 'dddd') },
				copy?.['$RELEASE_WEEK'] || 'In Theaters %DAY%'
			);
		}

		const dateFormat = getReleaseDateFormat(movie, copy);

		return getCopyWithParams(
			{ DATE: formatDateTime(releaseDate, dateFormat) },
			copy?.['$RELEASE_FUTURE'] || 'In Theaters %DATE%'
		);
	}

	return '';
}